import { defineNuxtPlugin } from "#app";
import type { Router } from "vue-router";

export default defineNuxtPlugin((nuxtApp) => {
   const $router = nuxtApp.$router as Router;
   // >> This is to put the teachable underneath the planning tools Route
   $router.addRoute({
      path: "/discipline/:discipline/planning-tool/:planningTool/teachable/:slug",
      name: "planning-tool-teachable",
      component: () =>
         import("~/pages/discipline/[discipline]/teachable/[slug].vue"),
      meta: {
         layout: "teachable", // Set the layout in the route's meta
      },
   });
   // >> This is to put the teachable underneath the Core Works Route
   $router.addRoute({
      path: "/discipline/:discipline/core-work/:corework/teachable/:slug",
      name: "core-work-teachable",
      component: () =>
         import("~/pages/discipline/[discipline]/teachable/[slug].vue"),
      meta: {
         layout: "teachable", // Set the layout in the route's meta
      },
   });
   // >> This is for the password creation from the onboarding email
   // $router.addRoute({
   //    path: "/teacher-password-create/welcome-:token",
   //    name: "user-onboard-password",
   //    component: () => import("~/pages/index/welcome-[token].vue"),
   //    meta: {
   //       layout: "logged-out", // Set the layout in the route's meta
   //    },
   // });

   // $router.addRoute({
   //    path: "/login",
   //    name: "login-modal",
   //    component: () => import("~/pages/[...slug].vue"),
   //    meta: {
   //       layout: "logged-out",
   //    },
   // });
   // $router.addRoute({
   //    path: "/forgot-password",
   //    name: "forgot-password-modal",
   //    component: () => import("~/pages/[...slug].vue"),
   //    meta: {
   //       layout: "logged-out",
   //    },
   // });
});
